import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { Col, Row, Tile } from '@op/opds.opux';
import TaskOne from './TaskOne';
import TaskTwo from './TaskTwo';
import CourseHeader from '../CourseHeader';
import { ReactComponent as Image29 } from '../../images/OP_symbolikuvitus_128_029.svg';
import { ReactComponent as Image288 } from '../../images/2021_OP_kertovakuvitus_288-18.svg';
import InfoTextBox1 from './InfoTextBox1';
import InfoTextBox2 from './InfoTextBox2';
import TextWaterfall from './TextWaterFall';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';
import PartTwo from './PartTwo';
import PartThree from './PartThree';
import PartFour from './PartFour';
import CourseComplete from '../CourseComplete';

const Course8 = (): ReactElement => {
  const firstIntro = useMessage('course8.courseContent.intro');
  const parsedFirstIntro = parseMsgContent(firstIntro);
  const partTwo = useMessage('course8.part1.content5');
  const parsedPartTwo = parseMsgContent(partTwo);
  const topics = useMessage('course8.responsibilityimage.topics') as Record<
    string,
    () => string
  >;
  const responsibilityImageTopics: string[] = Object.values(topics).map((msgFunc) =>
    msgFunc(),
  );
  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course8.title"
        courseHeaderText="learn_more"
        Image={Image29}
        courseNumber={8}
      />
      <CourseContent content={parsedFirstIntro} />
      <div className="investoracademy-number" style={{ marginTop: space.large }}>
        1
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <Message id="course8.part1.title" />
      </h2>
      <Row style={{ paddingBottom: space.xl, margin: 0 }}>
        <Col md={6} xs={12} className="investoracademy-multi-column-left">
          <p className="investoracademy-text-paragraph">
            <Message id="course8.part1.content1" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course8.part1.content2" />
          </p>
          <InfoTextBox1 />
        </Col>
        <Col md={6} xs={12} className="investoracademy-multi-column-right">
          <p className="investoracademy-text-paragraph">
            <Message id="course8.part1.content3" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course8.part1.content4" />
          </p>
          <InfoTextBox2 />
        </Col>
      </Row>
      <Tile>
        <h3 className="investoracademy-general-graph-title">
          <Message id="course8.responsibilityimage.title" />
        </h3>
        <ul className="text-waterfalls-container">
          <li className="svg-image" aria-hidden="true">
            <Image288 />
          </li>
          <TextWaterfall>
            {responsibilityImageTopics.map((message) => {
              return <li key={message}>{message}</li>;
            })}
          </TextWaterfall>
        </ul>
      </Tile>
      <CourseContent content={parsedPartTwo} />
      <div className="investoracademy-number" style={{ marginTop: space.large }}>
        2
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <Message id="course8.part2.title" />
      </h2>
      <PartTwo />
      <TaskOne />
      <PartThree />
      <PartFour />
      <TaskTwo />
      <CourseComplete messageId="course8.recap" />
    </div>
  );
};

export default Course8;
